export const navItems = [
  { label: "Product" },
  { label: "Services" },
  { label: "About" },
];

export const footerLinks = {
  landings: [
    { label: "Home", href: "#" },
    { label: "Products", href: "#" },
    { label: "Services", href: "#" },
  ],
  company: [
    { label: "Home", href: "#" },
    { label: "Careers", href: "#" },
    { label: "Services", href: "#" },
  ],
  resources: [
    { label: "Blog", href: "#" },
    { label: "Products", href: "#" },
    { label: "Services", href: "#" },
  ],
};
